const normalizeGroupUser = (user) => {
  return {
    id: user.line_id,
    displayName: user.display_name,
    imageURL: user.image_url,
    imageId: user.image_id,
    fromLine: user.from_line,
    coverCost: user.cover_cost,
    restrictedDestroy: user.restricted_destroy,
    restrictedCoverCost: user.restricted_cover_cost,
    remittanceInfo: user.remittance_info,
    hidden: user.hidden || false,
    hideable: user.hideable,
    accountingBooksCount: user.accounting_books_count,
    unsettledBooksCount: user.unsettled_books_count,
    accountingBooks: (user.accounting_books || []).map((book) => ({
      id: book.id,
      name: book.name,
      imageId: book.image_id,
      settled: book.settled
    }))
  }
}

export {
  normalizeGroupUser
}
